import { RefObject, useLayoutEffect } from 'react';

/** Space left under the box: the page body's padding and the shell's. */
const BOTTOM_GUTTER = 56;

/**
 * Give a box a min-height that runs to the bottom of the viewport from
 * wherever it starts on the page, so the last section of a page fills it
 * instead of ending in mid-air (and a menu opening from its last row has
 * room). Measured from the document top, not the scroll position, so
 * scrolling cannot feed back into the height.
 */
export function useFillToPageBottom(ref: RefObject<HTMLElement | null>, minPx = 360): void {
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;

    const fit = () => {
      const top = el.getBoundingClientRect().top + window.scrollY;
      const available = window.innerHeight - top - BOTTOM_GUTTER;
      el.style.minHeight = `${Math.max(minPx, Math.floor(available))}px`;
    };

    fit();
    const ro = new ResizeObserver(fit);
    ro.observe(document.body);
    window.addEventListener('resize', fit);
    return () => {
      ro.disconnect();
      window.removeEventListener('resize', fit);
      el.style.minHeight = '';
    };
  }, [ref, minPx]);
}
